import { render, staticRenderFns } from "./ParentListTable.vue?vue&type=template&id=8e3a5b96&scoped=true"
import script from "./ParentListTable.vue?vue&type=script&lang=js"
export * from "./ParentListTable.vue?vue&type=script&lang=js"
import style0 from "./ParentListTable.vue?vue&type=style&index=0&id=8e3a5b96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3a5b96",
  null
  
)

export default component.exports